import { Injectable, EventEmitter } from '@angular/core';
import {
  AsyncValidatorFn,
  AbstractControl,
  ValidationErrors,
} from '@angular/forms';
import {
  BaseFpxDataService,
  CreateFn,
  FindAllFn,
  FindByKeyFn,
  HttpRequest,
  LookUpFn,
  ModifyFn,
  CriteriaQuery,
  HttpProviderService,
  ILookUpData,
  FpxIHttpOption
} from '@fpx/core';
import { IHttpSuccessPayload,ILookupResponse } from '@fpx/core';
import { add } from '@amcharts/amcharts4/.internal/core/utils/Array';
import { map, Observable, of,catchError } from 'rxjs';
 import { ApplPendency, ApplPendencyMaintanence } from './applPendency.model';
import { environment } from 'src/environments/environment';
import { ProcessShellService } from 'src/app/process-shell/services/process-shell.service';
import { RloapplicationMaintanence } from 'src/app/rm/rloapplication-service/rloapplication.model';
@Injectable({
  providedIn: 'root'
})
export class ApplPendencyService implements BaseFpxDataService<any> {
  noResult: boolean;
  pendencydetails: any;
 constructor(private _httpProvider : HttpProviderService,
  private _processShellService: ProcessShellService) { }
  create(payload: ApplPendency,httpOption: Map<keyof FpxIHttpOption, Map<string, any>> = new Map()): CreateFn<any> {
    return () => {
      const httpRequest = new HttpRequest();
      httpRequest.setMethod('POST');
      httpRequest.setResource('/applPendency');
      let bodyContent = {"applPendency":payload};
      httpRequest.setBody(bodyContent);
      return this._httpProvider.invokeRestApi(httpRequest,httpOption);
    };
  }
 
  findByKey(key: ApplPendency,httpOption: Map<keyof FpxIHttpOption, Map<string, any>> = new Map()): FindByKeyFn<ApplPendency|null> {
    return () => {
      const httpRequest = new HttpRequest();
      httpRequest.setResource('/applPendency/{arn}');
       httpRequest.addPathParameter('arn', key.arn);
      httpRequest.setMethod('GET');
      return this._httpProvider
        .invokeRestApi(httpRequest,httpOption)
        .pipe(map((res: IHttpSuccessPayload<any>) => res.body?.applPendency ?? null),catchError((err:any) => {
              return of(null)
            }));
        
    };
  }

  modify(payload: ApplPendency,httpOption: Map<keyof FpxIHttpOption, Map<string, any>> = new Map()): ModifyFn<any> {
    return () => {
      const httpRequest = new HttpRequest();
      httpRequest.setResource('/applPendency/{arn}');
       httpRequest.addPathParameter('arn', payload.arn);
     httpRequest.setMethod('PUT');
      let bodyContent = {"applPendency":payload};
      httpRequest.setBody(bodyContent);
      return this._httpProvider.invokeRestApi(httpRequest,httpOption);
    };
  }
  
   delete(payload: ApplPendency,httpOption: Map<keyof FpxIHttpOption, Map<string, any>> = new Map()): ModifyFn<any> {
    return () => {
      const httpRequest = new HttpRequest();
      httpRequest.setResource('/applPendency/{arn}');
       httpRequest.addPathParameter('arn', payload.arn);
     httpRequest.setMethod('DELETE');
      let bodyContent = {"applPendency":payload};
      httpRequest.setBody(bodyContent);
      return this._httpProvider.invokeRestApi(httpRequest,httpOption);
    };
  }
  
   patch(payload: ApplPendency,httpOption: Map<keyof FpxIHttpOption, Map<string, any>> = new Map()): any {
    return () => {
      const httpRequest = new HttpRequest();
      httpRequest.setResource('/applPendency/{arn}');
       httpRequest.addPathParameter('arn', payload.arn);
     httpRequest.setMethod('PUT');
      let bodyContent = {"applPendency":payload};
      httpRequest.setBody(bodyContent);
      return this._httpProvider.invokeRestApi(httpRequest,httpOption);
    };
  }
  
   findAll(criteriaQuery: CriteriaQuery,httpOption: Map<keyof FpxIHttpOption, Map<string, any>> = new Map()): FindAllFn<any> {
   
    return () => {
      const httpRequest = new HttpRequest();
      httpRequest.setResource('/applPendency/{arn}');
      httpRequest.addPathParameter('arn', this._processShellService.arn);

      httpRequest.setMethod('GET');
      httpRequest.setCriteriaQuery(criteriaQuery);
      httpRequest.setServerContext(environment.customersPublisher);

      return this._httpProvider
        .invokeRestApi(httpRequest,httpOption)
        .pipe(
          map(
            (res: IHttpSuccessPayload<ApplPendencyMaintanence>) =>{
              
              this.pendencydetails = res.body?.applPendency || [];
              if(this.pendencydetails.length == 0 || res.status == 204 || res.status== 500) this.noResult = true;
              else this.noResult = false;
              this._processShellService.isSentbackApplication = !this.noResult;
             return{
              data: this.pendencydetails || [],
              totalRowCount: res.body?.totalRowCount
              }
            },
            catchError((err:any) => {
              this.noResult = true;
              return of(null)
            })
          )
        );
    };
  }

  lookup(key: any,httpOption : Map<keyof FpxIHttpOption, Map<string, any>> = new Map(), criteriaQuery?: CriteriaQuery | undefined): LookUpFn<any> {
    return () => {
    const httpRequest = new HttpRequest();
    httpRequest.setMethod('GET');
    httpRequest.setResource('/applPendency');
    httpRequest.addQueryParameter('lookup', 1);
    if(criteriaQuery){
        criteriaQuery?.addFilterCritertia('text','String','Contains',{
          searchText : key.searchText
        })
        httpRequest.setCriteriaQuery(criteriaQuery)
     }
    return this._httpProvider.invokeRestApi(httpRequest,httpOption).pipe(
        map((res: IHttpSuccessPayload<ILookupResponse>) => {
          return res.body?.Data || [];
        })
      );
    };
  }
  fetchStatistics(criteriaQuery: CriteriaQuery,httpOption: Map<keyof FpxIHttpOption, Map<string, any>> = new Map()): FindAllFn<any> {
    return () => {
      const httpRequest = new HttpRequest();
      httpRequest.setResource("/applPendency/statistics");
      httpRequest.setMethod("GET");
      httpRequest.setCriteriaQuery(criteriaQuery);
      return this._httpProvider
        .invokeRestApi(httpRequest,httpOption)
        .pipe(map((res: IHttpSuccessPayload<any>) => res.body));
    };
  }
  
}
